export const HEADER_HEIGHT = 64;
export const MODAL_Z_INDEX = 100;
export const NAVIGATION_DRAWER_Z_INDEX = 60;
